export function getMessagesMargin() {
    const desktop = window.innerWidth >= 1200;
    let margin = desktop ? 30 : 20;

    window.addEventListener("resize", () => {
        margin = window.innerWidth >= 1200 ? 30 : 20;
    });

    return margin;
}